import axios from "axios";
import React, { useEffect, useState } from "react";
import AdmissionProcessStep from "./AdmissionProcessStep";
const AdmissionProcess = () => {
  const [admissionProcesss, setAdmissionProcesss] = useState([]);
  const [selectedIndexs, setSelectedIndexs] = useState([]);

  useEffect(() => {
    axios.get("JSON/admissionProcess.json").then((response) => {
      setAdmissionProcesss(response.data[0]);
      setIntdexFuncton(response.data[0]?.steps);
    });
  }, []);

  const setIntdexFuncton = (steps) => {
    let newSelectedIndex = [];
    steps?.map((step, index) => {
      if (index + 1 === steps?.length) {
        newSelectedIndex.push(index);
      } else if ((index + 1) % 4 === 0) {
        newSelectedIndex.push(index);
      }
    });
    setSelectedIndexs(newSelectedIndex);
  };

  return (
    <section className="eschool-admission-process">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
            <div className="section-head ">
              <h3 className="section-head-title">
                {admissionProcesss?.header_title}
              </h3>
              <p className="section-head-text">
                {admissionProcesss?.sort_detail}
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {admissionProcesss?.steps?.map((step, index) => (
            <AdmissionProcessStep
              key={step?.id}
              step={step}
              ProcessArrow={admissionProcesss?.processImg}
              index={index}
              selectedIndexs={selectedIndexs}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdmissionProcess;
